module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctfm-alt"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Editor#edt",
      "id": "edt"
    }
  }, [_vm._v("Editor’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#int",
      "id": "int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction#int"
    }
  }, [_c('i', [_vm._v("It All Turns on Sentiment: John Crowe Ransom, Aesthetics, and Agrarian Economics")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Jay T. Collier")]), _vm._v(" "), _c('p', {
    staticClass: "bkau1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/lin2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Fm01#Fm1",
      "id": "Fm1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Land! The Case for an Agrarian Economy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Preface#pre",
      "id": "pre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter01#ch1",
      "id": "ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1. Homeless People and Vacant Land")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02#ch2",
      "id": "ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2. The Excess of Capital")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3. Some Proposed Extinguishers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4. The Amphibian Farmer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Appendix01#app",
      "id": "app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The State and the Land")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 69
// module chunks = 0